<template>
  <Layout is-demo>
    <div class="">
      <h1 class="text-h4">Payment Response</h1>
      <v-divider class="my-5"></v-divider>
    </div>
    <v-card
      class="mx-auto green lighten-2"
      max-width="700" 
      color="green-text"
      dark
      rounded="xl"
    >
      <v-row class="mx-0" style="overflow:hidden;"> 
        <v-col
          md="5"
          sm="12"
          class="green"
          align="center"
          justify="center"
        >
          <H2 class="text-h4 ">REMITA</h2>
          <div>Platform Payment</div>
          <v-divider class="my-4 white" color=" white--text"></v-divider>
          <div>Issuer:</div>
          <H2 class="text-h5">NFMP</h2>
          <v-divider class="my-4 white" color="white-text"></v-divider>
          <div>Amount:</div>
          <H2 class="text-h5">{{ amount }}</h2>
        </v-col>

        <v-col md="7" sm="12" color="green--text">
          <div class="d-flex justify-center" color="green--text">
            <v-icon 
              v-if="responseStatus"
              size="90"
              color="blue darken-2"
            >
              mdi-check-circle
            </v-icon>
            <v-icon 
              v-else
              size="90"
              color="red darken-2"
            >
              mdi-close-circle
            </v-icon>
          </div>
          <div class="text-h5 d-flex justify-center" color="green--text">
            RRR: {{ rrr }}
          </div>
          <v-divider class="my-2"></v-divider>
          <div class="py-2">
            <b>Status:</b> {{ status }}
          </div>
          <div class="py-2">
            <b>Transaction ID:</b>{{ transactionId }}
          </div>
          <div class="py-2">
            <b>Payment Date:</b> {{ paymentDate }}
          </div>
        </v-col>
      </v-row>
    </v-card>
    <v-snackbar v-model="snackbar" right>
      {{ snackbartext }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </Layout>
</template>

<script>
import Layout from '@/nfmp_components/layouts/MainPortalLayout'
import httpServ from '../services/HTTPService'
import sha512 from 'js-sha512'

export default {
  components: {
    Layout
  },
  data() {
    return {
      memberData:{},
      currentLOBDetails:{},
      prePostData:{},
      pageData:{},
      snackbar: false,
      snackbartext:'',
      showAlert:true,
      rrr:'',
      status:'',
      transactionId:'',
      paymentDate:'',
      responseStatus: false,
      amount:''
    }
  },
  created() {
    //http://localhost:8081/remitaResponse?RRR=171288183872&orderID=1753114610529
    this.merchantId = process.env.VUE_APP_REMITA_MERCHANTID
    this.apiKey = process.env.VUE_APP_REMITA_APIKEY
    
    const urlParams = new URLSearchParams(window.location.search)
    const RRR = urlParams.get('RRR')

    this.getRRRStatusFromServer(RRR)
  },

  mounted() {},
  methods: {
    getRRRStatusFromServer: function(RRR) {
      const postData = this.prePostData

      postData.RRR = RRR
      
      //const url = httpServ.getPaymentUrl('/remita/getStatus')
      const url = httpServ.getPaymentUrl('/remita/getRenewalRRRStatus')
      
      const resp = httpServ.postFetchWithToken(
        url,
        this.prePostData, //elapsed
        httpServ.getPaymentApiToken()
      )

      resp.then((result) => {
        //console.log(result.data)
        const { data } = result

        this.rrr =  data.rrr
        this.status = data.message
        this.transactionId = data.orderId
        this.paymentDate = data.paymentDate
        this.amount = data.amount
        if ( his.status === 'Successful') {
          responseStatus = true
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
